import {BaseStore, globalStore} from "../../stem-core/state/Store";

@globalStore
export class LanguageStore extends BaseStore("languageStore") {
    declare translationMap: any;
    static locale: LanguageStore;

    buildTranslation(callback: (translationMap: any) => void): void {
        callback(this.translationMap);
    }

    static getLocale(): LanguageStore {
        return this.locale || this.all()[0];
    }

    static setLocale(locale: LanguageStore): void {
        this.locale = locale;
        this.dispatch("localeChange", locale);
    }
}
